global.SERVER_URL = 'https://webapi.mytenvis.com'